import { useEffect, useState } from "react";
import butter from "../../utils/butter-client";
import { PostsList } from "./components/PostsList";
import { Access } from "../components/ui/Access";
import { BottomCTA } from "../components/ui/BottomCTA";
import { InfoBox } from "../components/form/InfoBox";
import { bottomCTA } from "../../datasets/blog/bottomCTA";

const pageSize = 6;

export const BlogMain = ({ initialPosts, initialCount }) => {
  const [attentionBox, setAttentionBox] = useState(false);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(initialCount);
  const [isLoading, setIsLoading] = useState();
  const [posts, setPosts] = useState(initialPosts);

  useEffect(() => {
    if (page === 1) return; // First page is SSRd
    setIsLoading(true);
    const pageSizeWithHero = pageSize + 1;

    butter.post
      .list({ page, page_size: pageSizeWithHero })
      .then(response => {
        const { data, meta } = response.data;
        setPosts(prevPosts => [...prevPosts, ...data]);
        setCount(meta.count);

        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  }, [page]);

  useEffect(() => {
    if (window.location.state) {
      const isInfoboxPresent = window.location.state.infobox;
      if (isInfoboxPresent) setAttentionBox(true);
    }
  }, []);

  function onLoadMoreClick() {
    setPage(prevPage => prevPage + 1);
  }

  const postsWithoutTail = posts.slice(0, pageSize * page + 1);

  return (
    <>
      {attentionBox && <InfoBox closeModal={() => setAttentionBox(false)} type="Attention" />}
      <section className="blog_main-main">
        <PostsList
          hasMore={postsWithoutTail.length < count}
          isLoading={isLoading}
          onLoadMoreClick={onLoadMoreClick}
          posts={postsWithoutTail}
        />
      </section>
      <Access skewed />
      <BottomCTA data={bottomCTA} />
    </>
  );
};
